import { render, staticRenderFns } from "./opmCurrentReport.vue?vue&type=template&id=6e3aae10"
import script from "./opmCurrentReport.vue?vue&type=script&lang=js"
export * from "./opmCurrentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports